export default __webpack_public_path__ + "static/media/gold-orange-spinner.73320af2.gif";